import React from 'react'
import DCHLogo from './DCH-Logo.svg'
import humiSVG from './humi.svg'
import humiIconSVG from './humi-icon.svg'
import cartSVG from './cart.svg'
import mapSVG from './map.svg'
import sadHumiSVG from './sad-humi.svg'
import closeSVG from './close.svg'
import isabellaSm from './onboarding-isabela-sm.svg'
import isabellaLg from './onboarding-isabela-lg.svg'
import humiLg from './onboarding-humi.svg'
import holeHumi from './humi-hole.svg'
import donutHumi from './humi-donut.png'
import emptyStateHumi from './humi-empty-state.png'
import humiSm from './humiSm.svg'
import linktLogo from './LinktLogo.svg'
import forgetPWLogo from './forgetPWHumi.png'
import rotateLeftSvg from './rotate-img-left.svg'
import rightRotationSvg from './rotate-img-right.svg'

export const moreIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 32 32'>
    <path
      fill='#000'
      fillRule='evenodd'
      d='M27 23a2 2 0 1 1 0 4H15a2 2 0 1 1 0-4h12zm0-8a2 2 0 1 1 0 4H6a2 2 0 1 1 0-4h21zm0-8a2 2 0 1 1 0 4H10a2 2 0 1 1 0-4h17z'
    />
  </svg>
)

export { default as isabela } from './isabela.png'

export const humi = humiSVG
export const humiIcon = humiIconSVG
export const humiS = humiSm
export const sadHumi = sadHumiSVG
export const close = closeSVG
export const cart = cartSVG
export const map = mapSVG
export const isabellaS = isabellaSm
export const isabellaL = isabellaLg
export const humiL = humiLg
export const noAnnouncementsHumi = holeHumi
export const noActivitiesHumi = donutHumi
export const humiEmptyState = emptyStateHumi
export const DCH = DCHLogo
export const forgetHumi = forgetPWLogo
export const leftRotationIcon = rotateLeftSvg
export const rightRotationIcon = rightRotationSvg

export const linkt = linktLogo

export const check = className => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='18'
      viewBox='0 0 23 18'
      className={className}>
      <path
        fillRule='evenodd'
        d='M8 12.032L4.495 8.505A2.115 2.115 0 0 0 1.5 8.5a2.12 2.12 0 0 0 0 3L8 17.997 21.501 4.5a2.121 2.121 0 0 0 0-3 2.12 2.12 0 0 0-3 .002L8 12.032z'
      />
    </svg>
  )
}
export const closeIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'>
      <path
        fillRule='evenodd'
        d='M9 6.299l5.74-5.74a1.91 1.91 0 0 1 2.7 2.701L11.702 9l5.74 5.74a1.91 1.91 0 0 1-2.701 2.7L9 11.702l-5.74 5.74a1.91 1.91 0 0 1-2.7-2.701L6.298 9 .559 3.26A1.91 1.91 0 1 1 3.26.56L9 6.298z'
      />
    </svg>
  )
}

export const questionCircleIcon = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M35 19.5c0 2.792-.698 5.375-2.094 7.75a15.662 15.662 0 0 1-5.656 5.656C24.875 34.302 22.292 35 19.5 35s-5.375-.698-7.75-2.094a15.662 15.662 0 0 1-5.656-5.656C4.698 24.875 4 22.292 4 19.5s.698-5.375 2.094-7.75a15.662 15.662 0 0 1 5.656-5.656C14.125 4.698 16.708 4 19.5 4s5.375.698 7.75 2.094a15.662 15.662 0 0 1 5.656 5.656C34.302 14.125 35 16.708 35 19.5zM19.937 9.125c-1.666 0-3.104.354-4.312 1.063-1.125.624-2.125 1.604-3 2.937a.625.625 0 0 0-.125.531.789.789 0 0 0 .313.469L15 15.75c.125.125.292.177.5.156a.685.685 0 0 0 .5-.281c.667-.792 1.188-1.333 1.563-1.625a3.355 3.355 0 0 1 2-.625c.708 0 1.364.198 1.968.594.604.396.907.885.907 1.469 0 .458-.188.854-.563 1.187-.25.208-.73.52-1.438.938l-.125.062c-1.041.583-1.77 1.104-2.187 1.563C17.375 19.979 17 20.916 17 22v.25c0 .208.073.385.219.531a.723.723 0 0 0 .531.219h3.5a.723.723 0 0 0 .531-.219.723.723 0 0 0 .219-.531v-.063c0-.333.167-.625.5-.875.208-.166.604-.416 1.188-.75 1.083-.666 1.854-1.25 2.312-1.75.792-.875 1.188-1.979 1.188-3.312 0-1.167-.355-2.24-1.063-3.219a7.44 7.44 0 0 0-2.75-2.312c-1.125-.563-2.27-.844-3.438-.844zm-.437 15.5c-.792 0-1.469.281-2.031.844a2.769 2.769 0 0 0-.844 2.031c0 .792.281 1.469.844 2.031.562.563 1.24.844 2.031.844.792 0 1.469-.281 2.031-.844.563-.562.844-1.24.844-2.031 0-.792-.281-1.469-.844-2.031a2.769 2.769 0 0 0-2.031-.844z'
        fill='#313D98'
        fillRule='evenodd'
      />
    </svg>
  )
}

export const uploadIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='25'
      viewBox='0 0 20 25'>
      <path
        fill='#FFF'
        fillRule='evenodd'
        d='M12.047 7.758v11.327a2.04 2.04 0 1 1-4.08 0V7.745l-4.484 4.392a2.062 2.062 0 0 1-2.885 0 1.978 1.978 0 0 1 0-2.826L9.974.125 10 .151l.026-.026 9.376 9.186a1.978 1.978 0 0 1 0 2.826 2.062 2.062 0 0 1-2.885 0l-4.47-4.38zM1.504 22h17a1.5 1.5 0 1 1 0 3h-17a1.5 1.5 0 0 1 0-3z'
      />
    </svg>
  )
}

export const downloadIcon = () => {
  return (
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.9992 0.199951H14.9992C15.3326 0.199951 15.6159 0.316618 15.8492 0.549951C16.0826 0.783285 16.1992 1.06662 16.1992 1.39995V9.79995H20.5992C21.0326 9.79995 21.3326 10.0083 21.4992 10.425C21.6659 10.8416 21.5992 11.2 21.2992 11.5L13.6992 19.1C13.4992 19.2999 13.2659 19.4 12.9992 19.4C12.7326 19.4 12.4992 19.2999 12.2992 19.1L4.69922 11.5C4.39922 11.2 4.33255 10.8416 4.49922 10.425C4.66588 10.0083 4.96589 9.79995 5.39922 9.79995H9.79922V1.39995C9.79922 1.06662 9.91588 0.783285 10.1492 0.549951C10.3826 0.316618 10.6659 0.199951 10.9992 0.199951ZM25.7992 19V24.5999C25.7992 24.9333 25.6826 25.2166 25.4492 25.4499C25.2159 25.6833 24.9326 25.7999 24.5992 25.7999H1.39922C1.06589 25.7999 0.782552 25.6833 0.549219 25.4499C0.315885 25.2166 0.199219 24.9333 0.199219 24.5999V19C0.199219 18.6666 0.315885 18.3833 0.549219 18.15C0.782552 17.9166 1.06589 17.7999 1.39922 17.7999H8.74922L11.1992 20.25C11.6992 20.75 12.2992 21 12.9992 21C13.6992 21 14.2992 20.75 14.7992 20.25L17.2492 17.7999H24.5992C24.9326 17.7999 25.2159 17.9166 25.4492 18.15C25.6826 18.3833 25.7992 18.6666 25.7992 19ZM19.5992 23.4C19.5992 23.1333 19.4992 22.9 19.2992 22.6999C19.0992 22.5 18.8659 22.4 18.5992 22.4C18.3326 22.4 18.0992 22.5 17.8992 22.6999C17.6992 22.9 17.5992 23.1333 17.5992 23.4C17.5992 23.6666 17.6992 23.9 17.8992 24.1C18.0992 24.2999 18.3326 24.4 18.5992 24.4C18.8659 24.4 19.0992 24.2999 19.2992 24.1C19.4992 23.9 19.5992 23.6666 19.5992 23.4ZM22.7992 23.4C22.7992 23.1333 22.6992 22.9 22.4992 22.6999C22.2992 22.5 22.0659 22.4 21.7992 22.4C21.5326 22.4 21.2992 22.5 21.0992 22.6999C20.8992 22.9 20.7992 23.1333 20.7992 23.4C20.7992 23.6666 20.8992 23.9 21.0992 24.1C21.2992 24.2999 21.5326 24.4 21.7992 24.4C22.0659 24.4 22.2992 24.2999 22.4992 24.1C22.6992 23.9 22.7992 23.6666 22.7992 23.4Z'
        fill='#00B9CF'
      />
    </svg>
  )
}

export const checkmarkIcon = () => {
  return (
    <svg
      width='27'
      height='23'
      viewBox='0 0 27 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.25 14.7898L4.8718 10.3837C3.839 9.34435 2.15832 9.34168 1.12222 10.3778C0.0882875 11.4117 0.0884663 13.0881 1.12262 14.1218L9.25 22.2457L26.1268 5.37466C27.1624 4.33945 27.1623 2.66064 26.1266 1.62555C25.0905 0.590028 23.4108 0.59138 22.3764 1.62857L9.25 14.7898Z'
        fill='#3DB988'
      />
    </svg>
  )
}

export const microphoneIcon = () => {
  return (
    <svg
      width='18'
      height='30'
      viewBox='0 0 18 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1 14.2893C1 18.5939 4.58172 22.0835 9 22.0835V22.0835C13.4183 22.0835 17 18.5939 17 14.2893'
        stroke='#49C294'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <rect x='5' width='8' height='18.1864' rx='3' fill='#49C294' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.99935 22.0836V28.1739V22.0836Z'
        fill='#49C294'
      />
      <path
        d='M8.99935 22.0836V28.1739'
        stroke='#49C294'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.3333 28.7009L3.66667 28.7009L14.3333 28.7009Z'
        fill='#49C294'
      />
      <path
        d='M14.3333 28.7009L3.66667 28.7009'
        stroke='#49C294'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  )
}

export const clockIcon = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 0.25C10.7279 0.25 13.75 3.27208 13.75 7C13.75 8.79021 13.0388 10.5071 11.773 11.773C10.5071 13.0388 8.79021 13.75 7 13.75C3.27208 13.75 0.25 10.7279 0.25 7C0.25 3.27208 3.27208 0.25 7 0.25ZM7 1.98314C4.22927 1.98314 1.98314 4.22927 1.98314 7C1.98314 9.77073 4.22927 12.0169 7 12.0169C9.77073 12.0169 12.0169 9.77073 12.0169 7C12.0169 4.22927 9.77073 1.98314 7 1.98314ZM7 2.51286C7.41958 2.51286 7.77343 2.81231 7.85129 3.22031L7.86312 3.3033L7.86657 3.37943L7.8664 6.6376L9.68972 8.46547C9.93711 8.71336 10.006 9.07904 9.88058 9.39656L9.84517 9.47484L9.80161 9.55054L9.74679 9.62519L9.68911 9.68911C9.39688 9.98133 8.94365 10.0229 8.60105 9.79887L8.52943 9.7468L8.4655 9.68911L6.17736 7.40097L6.13343 7.29491V3.37943C6.13343 2.90083 6.52141 2.51286 7 2.51286Z'
        fill='white'
      />
    </svg>
  )
}

export const calendarIcon = (isSelected = false) => {
  return (
    <svg
      width='25'
      height='22'
      viewBox='0 0 25 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        x='4.13'
        y='0.5'
        width='1.42'
        height='5.11111'
        rx='0.5'
        fill={isSelected ? '#00B9CF' : '#4A4A4A'}
        stroke={isSelected ? '#00B9CF' : '#4A4A4A'}
      />
      <rect
        x='18.65'
        y='0.5'
        width='1.42'
        height='5.11111'
        rx='0.5'
        fill={isSelected ? '#00B9CF' : '#4A4A4A'}
        stroke={isSelected ? '#00B9CF' : '#4A4A4A'}
      />
      <path
        d='M0 5.44438C0 3.78753 1.34315 2.44439 3 2.44439H21.2C22.8569 2.44439 24.2 3.78753 24.2 5.44439V8.5555H0V5.44438Z'
        fill={isSelected ? '#00B9CF' : '#4A4A4A'}
      />
      <rect
        x='1'
        y='3.44439'
        width='22.2'
        height='17.5556'
        rx='2'
        stroke={isSelected ? '#00B9CF' : '#4A4A4A'}
        strokeWidth='2'
      />
    </svg>
  )
}

export const carouselIcon = (isSelected = false) => {
  return (
    <svg
      width='24'
      height='20'
      viewBox='0 0 24 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M24 4C24 4.55228 23.5523 5 23 5H1C0.447716 5 0 4.55228 0 4V1C0 0.447715 0.447715 0 1 0H23C23.5523 0 24 0.447715 24 1V4ZM24 8.5C24 7.94772 23.5523 7.5 23 7.5H1C0.447716 7.5 0 7.94772 0 8.5V11.5C0 12.0523 0.447715 12.5 1 12.5H23C23.5523 12.5 24 12.0523 24 11.5V8.5ZM24 16C24 15.4477 23.5523 15 23 15H1C0.447716 15 0 15.4477 0 16V19C0 19.5523 0.447715 20 1 20H23C23.5523 20 24 19.5523 24 19V16Z'
        fill={isSelected ? '#00B9CF' : '#4A4A4A'}
      />
    </svg>
  )
}

export const instrumentIcon = (color = '#ffffff') => {
  return (
    <svg
      width='21'
      height='25'
      viewBox='0 0 21 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.72236 17.2774H15.2779V19.6663H5.72236V17.2774ZM5.72236 12.4996H15.2779V14.8885H5.72236V12.4996ZM12.889 0.555176H3.33347C2.01958 0.555176 0.94458 1.63018 0.94458 2.94406V22.0552C0.94458 23.3691 2.00764 24.4441 3.32152 24.4441H17.6668C18.9807 24.4441 20.0557 23.3691 20.0557 22.0552V7.72184L12.889 0.555176ZM17.6668 22.0552H3.33347V2.94406H11.6946V8.91629H17.6668V22.0552Z'
        fill={color}
      />
    </svg>
  )
}
export const editIcon = () => {
  return (
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_867_13017)'>
        <path
          d='M23.8307 26.0001H2.16406V21.6668H23.8307V26.0001ZM14.1457 5.6226L18.2082 9.6851L8.39323 19.5001H4.33073V15.4376L14.1457 5.6226ZM19.3674 8.52594L15.3049 4.46344L17.2874 2.48094C17.7099 2.05844 18.3924 2.05844 18.8149 2.48094L21.3499 5.01594C21.7724 5.43844 21.7724 6.12094 21.3499 6.54344L19.3674 8.52594Z'
          fill='#302E29'
        />
      </g>
      <defs>
        <clipPath id='clip0_867_13017'>
          <rect width='26' height='26' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const icons = {
  upload: uploadIcon()
}
